module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/starEmpty-47ad20ecbed2951a3f820973fb76c67b.svg";